export default {
    print: {
        menuLabel: 'Print',
        title: 'Print',
        allowanceLead: 'The publisher allows you to print {total} pages.',
        gauge: '{used} / {total}',
        gaugeLabel: 'Pages printed',
        jobLimit: 'Up to {limit} pages per print',
        pageFrom: 'Page from',
        pageTo: 'Page to',
        action: 'Print',
        historyTitle: 'Print history',
        historyRange: 'Pages {from} - {to}',
        reprint: 'Print',
        reprintRange: 'Reprint pages {from} - {to}',
        historyExpand: 'Show full print history',
        historyCollapse: 'Collapse print history',
        quotaExhausted:
            'You have reached your accumulated print limit for this book. You can still reprint previous ranges.',
        preparing: 'Generating your PDF of pages {from} - {to}…',
        ready: 'We are generating your PDF of pages {from} - {to}. You will receive it in your email shortly.',
        requestFailed: 'We could not generate your PDF. Please try again.',
        readerDelivery: {
            preparing: "We're preparing pages {from} - {to} for printing. This can take up to 60 seconds.",
            ready: 'Pages {from} - {to} are ready to print.',
            failed: "We couldn't prepare pages {from} - {to}. Your quota wasn't used.",
            retry: 'Try again',
        },
        errors: {
            invalidRange: 'Enter a valid page range.',
            jobLimit: 'You can print up to {limit} pages per print.',
            lifetime: 'You only have {remaining} pages left to print.',
        },
    },
    flashcards: 'Flashcards',
    chat: {
        title: 'Chat with this book',
    },
    readerPlugin: {
        loadFailed: 'The plugin could not be loaded.',
        retry: 'Retry',
    },
    flashcard: {
        create: 'New flashcard',
        created: 'Flashcard created.',
        updated: 'Flashcard updated.',
        createFailed: 'Could not create this flashcard.',
        updateFailed: 'Could not update this flashcard.',
        conversionFailed: 'Could not convert the highlight into a flashcard. Please try again.',
        createFromSelection: 'Create flashcard',
        edit: 'Edit',
        delete: 'Delete',
        front: 'Front',
        back: 'Back',
        frontPlaceholder: 'Write the front…',
        backPlaceholder: 'Write the back…',
        swapFrontBack: 'Swap front and back',
        flipCard: 'Tap to flip',
        studyAll: 'Study all',
        endStudy: 'End study',
        shuffle: 'Shuffle',
        progress: '{current} of {total}',
        fullscreen: 'Fullscreen',
        exitFullscreen: 'Exit fullscreen',
        goToSource: 'Go to page {page}',
        goToSourceEpub: 'Go to source',
        knowIt: 'Know it',
        dontKnowIt: "Don't know it",
        studyResult: 'Result: {know} of {total} ({percent}%)',
        studyAgain: 'Study again',
        studyDontKnow: "Study only the ones I don't know",
        studyDonePerfect: 'Congratulations!',
        studyDonePerfectHint: 'You got every card right. Great job!',
        studyDoneGreat: "You're almost there!",
        studyDoneGreatHint: "A couple more reviews and it's yours.",
        studyDoneKeep: 'Keep practicing!',
        studyDoneKeepHint: "One more review and you'll get it.",
        studyReviewLabel: 'To review',
        noFlashcards: 'You have not created any flashcards yet',
        noFilterFlashcards: 'There are no flashcards of this color',
        cancel: 'Cancel',
        save: 'Save',
        confirmDelete: {
            title: 'Delete flashcard',
            message: 'Are you sure you want to delete this flashcard? This action cannot be undone.',
        },
    },
    ai: 'AI Assistant',
    export: 'Export',
    footnotePanelTitle: 'Footnote',
    footnoteGoToNote: 'Go to note',
    blue: 'Blue',
    yellow: 'Yellow',
    pink: 'Pink',
    orange: 'Orange',
    rose: 'Pink',
    green: 'Green',
    all: 'All',
    generateApaCopy: 'Generate APA citation',
    apaCopied: 'Citation copied to clipboard!',
    imReading: `I'm reading`,
    in: 'in',
    by: 'By',
    article: 'Article',
    prevArticle: 'Previous Article',
    nextArticle: 'Next Article',
    imHere: `Yes, I'm here`,
    sessionExpiredAlert: 'Your reading session is about to end.',
    sessionExpiredAreYouThere: 'Are you there?',
    sessionExpired: 'Your reading session has expired due to inactivity.',
    returnToLibrary: 'Return to library',
    sessionValidExpired: 'Session expired',
    sessionValidExpiredPleaseLoginAgain: 'Please login again',
    tableOfContents: 'Table of Contents',
    tableOfContentsNotAvailable: 'No table of contents available.',
    pages: 'pages',
    page: 'page',
    thumbnails: 'Thumbnails',
    settings: 'Settings',
    bookmarks: 'Bookmarks',
    highlights: 'Highlights',
    highlight: 'Highlight',
    notes: 'Notes',
    note: 'Note',
    editNote: 'Edit note',
    openNote: 'Open note',
    notebook: 'Notebook',
    search: 'Search',
    theme: 'Theme',
    readingModes: 'Reading modes',
    zoomTitle: 'Text size',
    zoomTitlePdf: 'Zoom',
    zoomTimes: 'Times',
    typography: 'Typography',
    fontDefault: 'Default',
    lineSpacing: 'Line Spacing',
    lineSpacingCompact: 'Compact',
    lineSpacingNormal: 'Normal',
    lineSpacingWide: 'Wide',
    margins: 'Margins',
    marginsMinimum: 'Minimum',
    marginsNormal: 'Normal',
    marginsMaximum: 'Maximum',
    pageLayout: 'Page Layout',
    continuous: 'Continuous',
    onePage: 'Horizontal',
    onePageScroll: 'Vertical',
    twoPages: 'Double',
    twoPagesScroll: 'Two pages scrolling',
    citation: {
        buttons: {
            Iso690: 'Generate ISO690 citation',
            APA: 'Generate APA citation',
            Vancouver: 'Generate Vancouver citation',
            Chicago: 'Generate Chicago citation',
            ChicagoNotes: 'Notes',
            ChicagoBibliography: 'Bibliography',
            ChicagoAuthorDate: 'Author-Date',
            IEEE: 'Generate IEEE citation',
            MLA: 'Generate MLA citation',
            ABNT: 'Generate ABNT citation',
        },
        menu: {
            title: 'Generate citation',
            Iso690: 'ISO690 Citation',
            APA: 'APA Citation',
            Vancouver: 'Vancouver Citation',
            Chicago: 'Chicago Citation',
            ChicagoNotes: 'Notes',
            ChicagoBibliography: 'Bibliography',
            ChicagoAuthorDate: 'Author-Date',
            IEEE: 'IEEE Citation',
            MLA: 'MLA Citation',
            ABNT: 'ABNT Citation',
        },
        messages: {
            copied: 'Citation copied to clipboard!',
            availableIn: 'Available in',
            online: 'Internet',
            generated: 'cited',
            websiteName: 'publica.la',
            and: 'and',
        },
    },
    'ai-integrations': {
        buttons: {
            explain: 'Explain concept',
            expand: 'Expand information',
            summarize: 'Summarize idea',
        },
        menu: {
            title: 'AI Assistant (Beta)',
        },
        messages: {
            copied: 'Response copied to clipboard!',
            addedToResponse: '«Response copied from publica.la Reader»',
        },
        thanksFeedback: 'Thanks for your feedback!',
        errorFeedback: 'Sending feedback failed. Can you retry?',
    },
    onlyCopy: 'Copy plain text',
    translate: 'Translate',
    copy: 'copy',
    changeColor: 'Change color',
    socialShare: 'Share',
    zoom: {
        auto: 'Auto',
        'page-fit': 'Page Fit',
        'page-width': 'Page Width',
    },
    filter: 'Filter',
    noFilterHighlights: 'Select a filter to see your highlights',
    noFilterHighlightsColor: 'There is nothing highlighted in this color',
    noHighlights: 'You have not made highlights yet',
    noFilterNotes: 'Select a color to see your notes',
    noFilterNotesColor: 'There are no notes of this color',
    noNotes: 'You have not written notes yet',
    noFilterHighlightsAndNotes: 'Select a color to see your highlights and notes',
    noFilterHighlightsAndNotesColor: 'There is no notes or highlights of this color',
    noHighlightsAndNotes: 'You have not created any highlights or notes yet',
    noBookmarks: 'No bookmarks yet',
    bookmarkAdded: 'Bookmark added',
    bookmarkRemoved: 'Bookmark removed',
    bookmarkPageLabel: 'Page {page}',
    bookmarkFailed: 'Could not save this bookmark.',
    confirmDeleteBookmark: {
        title: 'Delete bookmark',
        message: 'Are you sure you want to delete this bookmark? This action cannot be undone.',
    },
    plainCopied: 'Text copied to clipboard!',
    onboarding: {
        tourOfferLead: 'New here?',
        tourOffer: 'Get to know the reader',
        tourCta: 'Get started',
        readerTour: 'Reader tour',
        next: 'Next',
        finish: 'Finish',
        skip: 'Skip tutorial',
        previous: 'Previous',
        reader: {
            welcome: {
                title: 'Welcome to your reading space',
                paragraph: 'Discover how to make the most of your books with the tools available in the reader.',
                extraParagraph: 'Enjoy your new reading space!',
            },
            highlights: {
                title: 'Enhance your reading experience',
                paragraph:
                    'Select text, highlight, create notes, generate quotes, translate, and listen to content. Take your reading experience to the next level in all formats.',
            },
            resumes: {
                title: 'Manage your content',
                paragraph:
                    'Boost your productivity. Manage your notes, highlights, quotes, and summaries at your convenience. Share your ideas quickly and easily.',
            },
            appPromote: {
                title: 'Read or listen anywhere',
                paragraph:
                    'Access your content whenever and however you want, without the need for an internet connection, on the device of your choice.',
                extraParagraph: 'Download our app!',
            },
        },
        audiobook: {
            welcome: {
                title: 'Welcome',
                subTitle: 'How to use the Audio Player?',
                paragraph: 'Learn how to make the most of your listening.',
            },
            reproduction: {
                title: 'Playback control',
                paragraph: 'Go back and forth, or pause audiobook playback.',
            },
            narratorSpeed: {
                title: 'Narration speed',
                paragraph: 'You can choose any speed you prefer with the audiobook currently listened to.',
            },
            chapters: {
                title: 'Chapters',
                paragraph: 'Move between chapters in an agile and fast way.',
            },
        },
    },
    tours: {
        addOnsEditor: {
            offerLead: 'New:',
            offer: 'create add-ons from the reader.',
            offerCta: 'Show me how',
            offerSkip: 'Not now',
            replay: 'Add-ons tour',
            replayAriaLabel: 'Add-ons tour',
            next: 'Next',
            done: 'Done',
            skip: 'Skip this step',
            close: 'Close the tour',
            progress: '{{current}} of {{total}}',
            steps: {
                create: {
                    title: 'New add-on',
                    text: 'Creates a piece anchored to the page you are on. We will open one now for practice; nothing is saved unless you publish it yourself.',
                },
                anchorBlock: {
                    title: 'Where the piece lives',
                    text: 'A new piece is anchored to the page: readers see a badge in the corner. The icons pick another kind of anchor. The pulsing marker on the page is the piece before it exists.',
                },
                pickText: {
                    title: 'Anchor to a passage',
                    text: 'Choose Passage in the anchor block.',
                },
                captureText: {
                    title: 'Select the passage',
                    text: 'Select the text the piece belongs to. Saving is disabled until the page answers.',
                },
                recapture: {
                    title: 'Change the passage',
                    text: 'This button asks the page again. Cancelling a capture restores the anchor you had.',
                },
                pickPoint: {
                    title: 'Anchor to a point',
                    text: 'Choose Point in the anchor block.',
                },
                capturePoint: {
                    title: 'Tap the point',
                    text: 'Tap where the marker should sit. Move the point asks again later.',
                },
                pointElsewhere: {
                    title: 'Points on fixed pages',
                    text: 'In a PDF or a fixed-layout EPUB you can also anchor a piece to a point on the page.',
                },
                captureImage: {
                    title: 'Anchor to an image',
                    text: 'Tap an image in the book and press + in the zoom. The practice piece is anchored to the image.',
                },
                imageElsewhere: {
                    title: 'Images in EPUBs',
                    text: 'In an EPUB you can also anchor a piece to an image, from the image zoom.',
                },
                turnPage: {
                    title: 'Turn the page while editing',
                    text: 'Use the page button to turn the page. The form stays open while you do.',
                },
                leaveQuestion: {
                    title: 'The piece is anchored here',
                    text: 'Stay keeps the anchor. Go moves it: a passage is asked for again on the new page; a point keeps its spot there, and a page or an image anchor moves by itself. Answer either way.',
                },
                captureAgain: {
                    title: 'Anchor it on this page',
                    text: 'Capture the passage again, or cancel the capture to keep editing.',
                },
                preview: {
                    title: 'Preview',
                    text: 'Shows the piece as a reader would open it. The form hides meanwhile.',
                },
                draft: {
                    title: 'Draft',
                    text: 'A draft is seen only by editors: readers do not see it in the list, the badge or the page. Its marker takes a dashed border.',
                },
                publishing: {
                    title: 'Save draft or publish',
                    text: 'Save draft keeps the work unpublished. Publish asks once in the footer and then makes the piece visible; it cannot be unpublished, so a published piece only offers Save. A saved draft autosaves every change.',
                },
                finish: {
                    title: 'That is it',
                    text: 'This practice piece is discarded now. Replay the tour any time from the ? in the panel or the menu.',
                },
            },
        },
    },
    author: 'Author',
    publisher: 'Publisher',
    narrator: 'Narrator',
    narratedBy: 'Narrated by',
    aboutThisPublication: 'About this publication',
    listening: {
        label: 'Listen',
        voice: 'Voice',
    },
    searchResultEmpty: 'No results found',
    searchLengthError: 'Search must be between 4 and 128 characters',
    keepTyping: 'Keep typing…',
    loading: 'Loading...',
    searchLoading: 'Searching...',
    searchTitle: 'Search',
    lastSearch: 'Suggestions',
    searchExplanation: 'Find words in an agile way on all publication',
    networkIsOffline: 'No internet connection available. Some features are unavailable.',
    about: 'About',
    chapters: 'Chapters',
    duration: 'Duration',
    narratorSpeed: 'Narrator speed',
    slowNarration: 'Slow storytelling',
    normalNarration: 'Normal storytelling',
    fastNarration: 'Fast storytelling',
    shareIssue: 'Share publication',
    shareArticle: 'Share Add-on',
    copyUrl: 'Copy URL',
    shareCurrentPage: 'Share current page',
    shareCurrentPosition: 'Share current position',
    copyUrlToClipboard: 'URL copied to clipboard',
    tooltips: {
        zoomOut: 'Zoom out',
        zoomIn: 'Zoom in',
        config: 'Configuration',
        tableOfContents: 'Table of contents',
        search: 'Search',
        highlights: 'Highlights',
        notebook: 'Notebook',
        listen: 'Listen',
        bookmarks: 'Bookmarks',
        openThumbnails: 'Thumbnails',
        closeThumbnails: 'Exit thumbnails',
        openFullscreen: 'Full screen',
        closeFullscreen: 'Exit full screen',
        download: 'Offline Access',
        share: 'Share',
        prev: 'Prev',
        next: 'Next',
        close: 'Close',
        back: 'Back',
        themeTitle: 'Appearance',
        themeLight: 'Light',
        themeDark: 'Dark',
        themeCream: 'Cream',
        themeSepia: 'Sepia',
        themeCyan: 'Cyan',
        themeHighContrast: 'High contrast',
        themeHighContrastDark: 'High contrast dark',
        clear: 'Clear',
        citation: 'Citation',
        dictionary: 'Dictionary',
        aiIntegrations: 'AI Assistant (Beta)',
        aiAction:
            'This tool uses AI, so there may be inaccurate information. More improvements coming soon! What do you think? Use the icons below to share your thoughts.',
        translate: 'Translate',
        about: 'About',
        rewind: 'Rewind',
        forward: 'Forward',
        createNote: 'Create a note',
        createHighlight: 'Highlight',
        deleteHighlight: 'Delete highlight',
        help: 'Help',
        lists: 'Lists',
        copy: 'Copy',
        goodResponse: 'Good response',
        badResponse: 'Bad response',
        ai: 'AI assistant',
        moreActions: 'More actions',
        moreOptions: 'More options',
        selectionTools: 'Selection tools',
        play: 'Play',
        pause: 'Pause',
        seekPosition: 'Track position',
        zoomReset: 'Reset zoom',
        themeSystem: 'System theme',
        searchInBook: 'Search in book',
        pageSlider: 'Page navigation',
    },
    save: 'Save',
    delete: 'Delete',
    cancel: 'Cancel',
    confirmDelete: {
        title: 'Delete notebook',
        message: 'Are you sure you want to delete this notebook? This action cannot be undone.',
    },
    confirmResetSettings: {
        title: 'Reset settings',
        message: 'All visual settings will be restored to their default values.',
    },
    resetSettings: 'Reset settings',
    edit: 'Edit',
    remove: 'Remove',
    add: 'Add',
    yourHighlighters: 'Your highlighters',
    quickHighlight: 'Quick highlight',
    quickHighlightTooltip: 'Instantly applies your active color when you select text',
    quickHighlightCreated: 'Highlight created',
    newHighlighter: 'New highlighter',
    editHighlighter: 'Edit highlighter',
    changeHighlighterColor: 'Change color',
    highlighterInUse: 'Has highlights assigned',
    highlighterDeletionFailed: 'Could not delete this highlighter.',
    highlightCreationFailed: 'Could not create this highlight.',
    highlightDeletionFailed: 'Could not delete this highlight.',
    settingsSaveFailed: 'Could not save your settings. Please try again.',
    settingsSaveRetry: 'Try again',
    audioPlaybackFailed: 'This track could not be played. Please try again.',
    highlighterNamePlaceholder: 'Highlighter name...',
    confirmDeleteHighlighter: {
        title: 'Delete highlighter',
        message: 'Are you sure you want to delete the highlighter "{label}"? This action cannot be undone.',
    },
    writeNote: 'Write a note',
    clickToToggle: 'Click to show the full passage',
    richText: {
        toolbar: 'Formatting',
        bold: 'Bold',
        italic: 'Italic',
        underline: 'Underline',
        strikethrough: 'Strikethrough',
        heading: 'Heading {level}',
        blockquote: 'Quote',
        aside: 'Box',
        bulletList: 'Bulleted list',
        orderedList: 'Numbered list',
        link: 'Insert link',
        unlink: 'Remove link',
        linkPrompt: 'Link URL',
        image: 'Insert image',
        imagePrompt: 'Image URL',
        html: 'Edit HTML',
        discard: {
            intro: 'Some content will not be kept when saved:',
            tag: 'Unsupported format: {detail}',
            unsafe: 'Unsafe content removed: {detail}',
            embedDomain: 'Embeds from {detail} are not allowed',
            embedUrl: 'This {detail} page cannot be embedded: use the link to a video or audio',
            dismiss: 'Dismiss notice',
        },
        embed: {
            offer: 'Insert the video from {host}?',
            offerAudio: 'Insert the audio from {host}?',
            insert: 'Insert video',
            insertAudio: 'Insert audio',
            keepLink: 'Keep as link',
            play: 'Play video from {host}',
            playAudio: 'Play audio from {host}',
        },
    },
    speakNow: 'Speak now',
    listeningSpeech: 'Listening',
    addOns: {
        batchOpen: 'Import',
        batchTitle: 'Import add-ons',
        batchIntro:
            'Paste a range from your spreadsheet, or choose its file. The first row names the columns, and each row under it becomes a draft on its page.',
        batchColumnsHint: 'Columns: {columns}. Only the title and the page are required.',
        batchUpload: 'Choose a file',
        batchDropHint: 'or drop it here · .xlsx, .csv, .tsv or .txt',
        batchPasteLabel: 'Or paste the range',
        batchPastePlaceholder:
            'title,page,content\nInterview with the author,12,https://vimeo.com/889120441\nGlossary,30,The terms the book uses.',
        batchRead: 'Preview',
        batchBack: 'Back',
        batchCancel: 'Cancel',
        batchConfirm: 'Add drafts · {count}',
        batchSummary: 'Ready: {ready} · Skipped: {skipped}',
        batchUnrecognized: 'Columns left out: {columns}',
        batchCaption: 'What the import will add',
        batchShowAll: 'Show all',
        batchShowLess: 'Show less',
        batchColumnLine: 'Row',
        batchColumnStatus: 'Status',
        batchColumnPage: 'Page',
        batchColumnType: 'Icon',
        batchColumnInsertAs: 'Insert as',
        batchInsertedEmbed: 'Embedded',
        batchInsertedLink: 'Link',
        batchReady: 'Ready',
        batchSkipped: 'Skipped: {reason}',
        batchReasonTitleMissing: 'no title',
        batchReasonPageMissing: 'no page',
        batchReasonPageInvalid: 'the page is not a whole number',
        batchReasonPageOutOfRange: 'the publication has {total} pages',
        batchReasonPageUnplaceable: 'this page cannot be found in the book',
        batchReasonTooLong: '{field} is longer than {max} characters',
        batchReasonContentEmptied: 'the content rules remove everything in it',
        batchReasonDuplicateExisting: 'already in this publication',
        batchReasonDuplicateRow: 'same title and page as row {line}',
        batchWarnEmbedFellBackToLink: 'added as a link: this site cannot be embedded',
        batchWarnImageUrlInvalid: 'the image is not a URL and is left out',
        batchWarnImageUnreachable: 'the image did not load here: the piece may end up without it',
        batchWarnInsertAsUnknown: 'unknown way to insert: it is chosen from the content',
        batchWarnTruncated: '{field} is cut at {max} characters',
        batchWarnTypeUnknown: 'unknown icon: it is chosen from the content',
        batchErrorEmpty: 'There are no rows under the header.',
        batchErrorMissingColumns: 'The sheet needs a column for: {columns}.',
        batchErrorTooManyRows: 'Up to {max} rows can be imported at once.',
        batchErrorUnsupportedFile: 'Choose an .xlsx, .csv, .tsv or .txt file.',
        batchErrorTooLarge: 'The file is larger than {max} MB. Split the sheet, or paste the range.',
        batchErrorUnreadable: 'This file cannot be read as a spreadsheet.',
        batchErrorXlsxUnsupported: 'This device cannot open .xlsx files. Save the sheet as CSV, or paste the range.',
        batchDraftsNote: 'They are added as drafts on their page. Anchor each one from the list when it is ready.',
        batchProgressCreating: 'Adding drafts · {done} of {total}',
        batchImagesFollow: 'Images take a few minutes and show the next time you open the publication.',
        batchDone: 'Drafts added: {created}',
        batchDoneWithFailures: 'Drafts added: {created} · With problems: {failed}',
        batchFailuresToggle: 'See the problems',
        batchFailureCreate: 'Row {line}, {title}: not added. {reason}',
        batchImageIssue: 'Row {line}, {title}: added, but its image did not load here, so it may end up without it.',
        batchFailureNoReason: 'It could not be saved, perhaps because the connection dropped.',
        batchRetryMissing: 'To add the missing ones, import the same sheet again: the ones already added are skipped.',
        batchDismiss: 'Dismiss',
        batchAnnounceStarted: 'Adding drafts: {count}',
        batchAnnounceDoneWithFailures: 'Drafts added: {created}. With problems: {failed}',
        title: 'Add-ons',
        previous: 'Previous',
        next: 'Next',
        position: '{current} of {total}',
        listKeysHint: 'Use the arrow keys to move through the list.',
        currentPage: 'you are here',
        search: 'Search add-ons…',
        empty: 'No add-ons in this publication',
        pageBadge: 'Add-ons on this page · {count}',
        pageList: 'Add-ons on this page',
        types: { article: 'Article', video: 'Video', audio: 'Audio', image: 'Image', link: 'Link', '3d': '3D' },
        backToList: 'List',
        addToImage: 'Add an add-on to this image',
        anchorToImage: 'Anchor the add-on to this image',
        create: 'New add-on',
        createFromSelection: 'Create add-on',
        edit: 'Edit add-on',
        preview: 'Preview',
        exitPreview: 'Exit preview',
        delete: 'Delete',
        deleteConfirm: 'Delete "{title}"? Readers will no longer see it.',
        publishConfirm: 'Publish "{title}"? All readers will be able to see it.',
        keepDraft: 'Keep as draft',
        cancel: 'Cancel',
        publish: 'Publish',
        save: 'Save',
        saveDraft: 'Save draft',
        back: 'Back',
        saveFailed: 'Could not save the add-on. Please try again.',
        deleteFailed: 'Could not delete the add-on. Please try again.',
        titleLabel: 'Title',
        characterCount: '{count} of {max} characters',
        titlePlaceholder: 'The title readers will see',
        titleRequired: 'Enter a title',
        untitled: 'Untitled',
        draft: 'Draft',
        textSmaller: 'Smaller text',
        textLarger: 'Larger text',
        textSize: 'Text size {percent}%',
        iconMenuTitle: 'Icon on the page',
        iconAuto: 'Automatic',
        content: 'Content',
        bodyPlaceholder: 'Write what readers will see…',
        moreDetails: 'More details',
        moreDetailsHint: 'Topic, author, subtitle, image',
        pretitle: 'Topic',
        pretitlePlaceholder: 'e.g. Transport',
        author: 'Author',
        authorPlaceholder: 'e.g. Marina Ferreyra',
        byLine: 'Subtitle',
        byLinePlaceholder: 'e.g. Turn to explore the model',
        imageUrl: 'Image URL',
        imageUrlPlaceholder: 'https://…',
        imageFile: 'Image file',
        imageUnreadable: 'This image could not be read. Choose another file.',
        imageCaption: 'Image caption',
        imageCaptionPlaceholder: 'Describe the image…',
        anchorKinds: 'Anchor',
        anchorKindPage: 'Page',
        anchoredToPage: "Anchored to page {page} · readers see the badge in the page's corner",
        anchorKindPoint: 'Point',
        anchoredToPoint: 'Anchored to a point on page {page} · readers see the marker where it sits',
        anchorKindText: 'Passage',
        anchoredToText: 'Anchored to a passage on page {page} · readers see the marker beside it',
        anchorKindImage: 'Image',
        anchoredToImage: 'Anchored to an image · readers see the marker at its corner',
        placeHere: 'Tap where the icon should sit',
        placeHereOnPage: 'Tap where the icon should sit on page {page}',
        announcePublished: 'Add-on published',
        announceDraftSaved: 'Draft saved',
        announceSaved: 'Changes saved',
        announceDeleted: 'Add-on deleted',
        announcePointPlaced: 'Point placed on page {page}',
        announcePointPlacedNoPage: 'Point placed',
        anchorAwaitingText: 'Select a passage on the page',
        changePassage: 'Change the passage',
        movePoint: 'Move the point',
        leavePageTitle: 'Leave page {page}?',
        leavePageMessage:
            'This add-on is anchored to page {page}. If you turn the page, its anchor moves to the new one.',
        leavePagePlaceMessage:
            'This add-on is anchored to page {page}. If you turn the page, you will place it again on the new one.',
        leavePageStay: 'Stay on page {page}',
        leavePageGo: 'Go',
    },
    share: {
        copyShare: 'Copy and share',
        qrCodeTitle: 'QR Code',
        scanQr: 'Scan the QR code using your WeChat app',
        copyLink: 'Copy the publication URL',
        copy: 'Copy',
        copied: 'copied!',
        openWechat: 'Open WeChat app',
        openingWechat: 'Opening WeChat app...',
        sendCopiedUrl: 'Send copied URL to a contact',
    },
    playing: 'Playing',
    buyNow: 'Buy now',
    buyNowText: 'Get the full version.',
    preview: 'Sample',
    changeLayoutNotAllowed: 'The content does not allow to change the page layout',
    nativeTtsLang: {
        'en-US': 'English (United States)',
        'en-GB': 'English (United Kingdom)',
        'en-scotland': 'English (Scotland)',
        'en-AU': 'English (Australia)',
        'en-IE': 'English (Ireland)',
        'en-IN': 'English (India)',
        'en-ZA': 'English (South Africa)',
        en: 'English',
        'es-AR': 'Spanish (Argentina)',
        'es-ES': 'Spanish (Spain)',
        'es-MX': 'Spanish (Mexico)',
        'es-US': 'Spanish (United States)',
        es: 'Spanish',
        'it-IT': 'Italian (Italy)',
        it: 'Italian',
        'pt-PT': 'Portuguese (Portugal)',
        'pt-BR': 'Portuguese (Brazil)',
        pt: 'Portuguese',
        'fr-CA': 'French (Canada)',
        'fr-FR': 'French (France)',
        fr: 'French',
        pl: 'Polish',
        'pl-PL': 'Polish (Poland)',
    },
    promoteApp: {
        downloadAppStore: 'Download on the App Store',
        downloadPlayStore: 'Get it on Google Play',
        title_read: 'Take your readings wherever you go with',
        title_audio: 'Take your audiobooks wherever you go with',
        text: 'Access your content whenever and however you want, without needing an internet connection, on the device of your choice. Download our app!',
        title_first_part: 'With',
        title_second_part: 'take your reading wherever you go',
    },
    dictionary: 'Dictionary',
    selectionTooLongLine1: 'The selection has too many words.',
    selectionTooLongLine2: 'Try selecting up to 5 words.',
    dictionaryValidation: {
        message: 'You selected {count} words.\nPlease try selecting up to {max} words.',
    },
    translateValidation: {
        message: 'You selected {count} characters.\nPlease try selecting up to {max} characters.',
    },
    ttsValidation: {
        message: 'You selected {count} characters.\nPlease try selecting up to {max} characters.',
    },
    aiValidation: {
        message: 'You selected {count} characters.\nPlease select between {min} and {max} characters.',
    },
    alreadyPurchased: 'Already purchased?',
    logIn: 'Log in',
    addToAList: 'Add to a list',
    lists: 'Lists',
    nextSection: 'Next section',
    prevSection: 'Previous section',
    new: 'New',
    skipLinks: {
        navLabel: 'Skip links',
        showControls: 'Show controls',
    },
    accessibility: {
        textSelected: '{count} characters selected. Selection tools available.',
        pageChanged: 'Page {current} of {total}',
    },
    sharing: {
        shareMyHighlights: 'Share my highlights',
        shareCollection: 'Share',
        shareWithOthersDescription:
            'Share your highlights with other users. Pick a collection. Others will follow your highlights as you add new ones.',
        noHighlightsToShare: 'You have no highlights yet. Add some highlights to start sharing.',
        copyLink: 'Copy link',
        linkReady: 'Link ready!',
        linkCopied: 'Link copied to clipboard!',
        shareVia: 'Share via',
        exportHighlights: 'Export highlights',
        sharedBy: 'Shared by',
        sharedWithMe: 'Shared with me',
        shareLinkFailed: 'Could not generate the share link. Please try again.',
        copyToClipboardFailed: 'Could not copy to clipboard. Please try again.',
        noShareableColors: 'Only custom colors can be shared. Create one to start sharing.',
        subscriptionConfirmed: 'You can now see the notes {author} shared with you in {title}.',
        subscriptionSelfNotAllowed: 'You cannot subscribe to a color you shared yourself.',
    },
    notebookExport: {
        generating: 'Generating PDF…',
        failed: 'Could not generate the PDF.',
        retry: 'Try again',
        ready: 'Your PDF is ready.',
        download: 'Download',
        tooMany: 'You can export up to {max} annotations. Filter by color to export them in parts.',
    },
    unsupportedFormat: 'This publication cannot be opened in this version of the reader. Please try again later.',
};
